import { TIPO_ARTICULO } from "api/Types/TipoArticulo"
import { TFunction } from "i18next"

export const SIN_CATEGORIA = "Sin categoría"

export const REPLACE_KEYS_TO_TREE_OBJ = {
  subCategorias: "children",
  nombre: "title",
}

export const TIPO_ARTICULOS_OPTIONS_NUEVO = (t: TFunction) => ({
  [TIPO_ARTICULO.SERVICIO]: {
    label: t("articulos.tab.serviceLabel"),
    value: TIPO_ARTICULO.SERVICIO,
  },
  [TIPO_ARTICULO.PRODUCTO]: {
    label: t("articulos.tab.productLabel"),
    value: TIPO_ARTICULO.PRODUCTO,
  },
})

export const TIPO_ARTICULOS_OPTIONS = (t: TFunction) => [
  {
    label: `${t("articulos.tab.serviceLabel")}`,
    value: 0,
  },
  {
    label: `${t("articulos.tab.productLabel")}`,
    value: 1,
  },
]

export const CATEGORIAS_COLUMN_HEADER = "CATEGORIAS_COLUMN_HEADER"
